import pythonApiClient from "./pythonBaseApi";

const homologacionCamasLogiflexApi = {
  /**
   * Ejecuta homologación SGC ↔ Logiflex (vista previa o aplicar).
   * @param {number} proyectoId
   * @param {{ aplicar?: boolean, hotel?: string, limit?: number }} options
   */
  ejecutar: (proyectoId, options = {}) => {
    const { aplicar = false, hotel, limit = 5000 } = options;
    return pythonApiClient.post(
      "/procesos/hoteleria/homologacion-camas-logiflex/ejecutar",
      { aplicar, hotel, limit },
      {
        headers: { "X-Proyecto-ID": proyectoId },
      }
    );
  },

  /**
   * Valida camas ya homologadas: id_proveedor vs catálogo Logiflex (solo lectura).
   * @param {number} proyectoId
   * @param {{ hotel?: string, limit?: number }} options
   */
  validarHomologadas: (proyectoId, options = {}) => {
    const { hotel, limit = 5000 } = options;
    return pythonApiClient.post(
      "/procesos/hoteleria/homologacion-camas-logiflex/validar-homologadas",
      { hotel, limit },
      {
        headers: { "X-Proyecto-ID": proyectoId },
      }
    );
  },

  /**
   * Sincroniza masivo SGC → Logiflex (crear/actualizar, codigo = id SGC).
   */
  sincronizar: (proyectoId, options = {}) => {
    const {
      aplicar = false,
      crear = true,
      actualizar = true,
      cama_ids = null,
      hotel = "CAMPAMENTO",
      limit = 5000,
    } = options;
    return pythonApiClient.post(
      "/procesos/hoteleria/homologacion-camas-logiflex/sincronizar",
      { aplicar, crear, actualizar, cama_ids, hotel, limit },
      {
        headers: { "X-Proyecto-ID": proyectoId },
      }
    );
  },

  /**
   * Homologa una sola cama hacia Logiflex.
   */
  sincronizarUna: (proyectoId, camaId, hotel = "CAMPAMENTO") => {
    return pythonApiClient.post(
      `/procesos/hoteleria/homologacion-camas-logiflex/sincronizar/${camaId}`,
      {},
      {
        params: { hotel },
        headers: { "X-Proyecto-ID": proyectoId },
      }
    );
  },

  /**
   * Descarga Excel con resultado de homologación.
   */
  exportExcel: (proyectoId, params = {}) => {
    return pythonApiClient.get(
      "/procesos/hoteleria/homologacion-camas-logiflex/export/excel",
      {
        params,
        headers: { "X-Proyecto-ID": proyectoId },
        responseType: "blob",
      }
    );
  },
};

export default homologacionCamasLogiflexApi;
